<div
  class="loading-indicator-container"
  [style.position]="position"
  [style.z-index]="zIndex">
  <div class="loading-indicator" [style.color]="textColor">
    <mat-spinner [diameter]="spinnerSize"></mat-spinner>
    {{ text | translate}}
  </div>
</div>
